import React from 'react';
import { Routes, Route,  BrowserRouter } from 'react-router-dom';
import Home from './screens/Home';
import Post from './screens/Post';
import Header from './components/Header';
import AdultWarning from './components/AdultWarning';

const App = () => {
  // Helper to check if 'isAdult' cookie is set to 'true'
  const isAdult = document.cookie
    .split('; ')
    .find(row => row.startsWith('isAdult='))
    ?.split('=')[1] === 'true';

  return (
    <>
      {!isAdult && <AdultWarning />}
      <BrowserRouter>
        <div className="min-h-screen bg-pink-100 text-black px-4 py-6  pt-[75px]  pb-[75px] md:pt-[95px] md:pt-[75px]">
          <Header />
          <Routes>
            <Route path="/" element={<Home />} />
            <Route path="/post/:slug" element={<Post />} />
          </Routes>
        </div>
      </BrowserRouter>
    </>
  );
};

export default App;

